// v86 — the owner's silent demo keys: each flips the existing "your view" switch (Admin → Clients) and reloads,
// so every page goes through the same access gates a team without that feature gets. Nothing is shown.
import { api } from "@/lib/api";

const PREV = "kolradar.botmode.prev";

export const DEMO_FEATURES = {
  c360: { key: "KeyC", get: () => api.get("/admin/creator360").then((r) => !!r.data.me_hidden), set: (hide) => api.put("/admin/creator360/me", { hidden: hide }) },
  live: { key: "KeyL", get: () => api.get("/admin/live-intel").then((r) => !!r.data.me_hidden), set: (hide) => api.put("/admin/live-intel/me", { hidden: hide }) },
  bot: {
    key: "KeyB",
    get: () => api.get("/admin/bot-check").then((r) => (r.data.me?.mode || "open") === "off"),
    set: async (hide) => {
      if (hide) {
        const cur = (await api.get("/admin/bot-check")).data.me?.mode || "open";
        try { localStorage.setItem(PREV, cur === "off" ? "open" : cur); } catch { /* private mode */ }
        return api.put("/admin/bot-check/me", { mode: "off" });
      }
      let prev = "open";
      try { prev = localStorage.getItem(PREV) || "open"; } catch { /* private mode */ }
      return api.put("/admin/bot-check/me", { mode: prev === "like_clients" ? "like_clients" : "open" });
    },
  },
  // v87 — Shift + R: the Reserve check on/off; the picked teams are kept. Here the state is "on", not "hidden".
  rc: {
    key: "KeyR",
    get: () => api.get("/admin/reserve-check").then((r) => !!r.data.on),
    set: async (on) => { const { teams } = (await api.get("/admin/reserve-check")).data; return api.put("/admin/reserve-check", { on, teams }); },
  },
};

export async function flipFeature(name) {
  const f = DEMO_FEATURES[name];
  const hidden = await f.get();
  await f.set(!hidden);
  window.location.reload();
}

export const featureForKey = (code) => Object.keys(DEMO_FEATURES).find((k) => DEMO_FEATURES[k].key === code);
